module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0040_certificate_information_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "証書情報（詳細）(old)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "25%",
      "float": "left",
      "margin-left": "-25px",
      "min-width": "100px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("更新日：" + _vm._s(_vm.registrationDate))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("登録日：" + _vm._s(_vm.registrationDate))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        承認状態：\n        "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "90px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.approvalStatus
    }
  }), _vm._v("\n        状態:\n        "), _c('select', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "90px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.Status
    },
    on: {
      "change": function($event) {
        _vm.Status = $event.target.value
      }
    }
  }, _vm._l((_vm.StatusOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "selected": option == _vm.Status,
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  })), _vm._v("\n        申請No：\n        "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "140px",
      "padding-left": "4px",
      "margin": "2px",
      "margin-bottom": "-6px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px",
      "color": "#008cff",
      "text-decoration": "underline"
    },
    attrs: {
      "type": "button",
      "value": _vm.approvalHistoryTorokuNumber
    },
    on: {
      "click": _vm.onConfirmExecuteProcessConfirmation
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.formFields.col2b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == true),
      expression: "isAdminSavingApplication == true"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "-10px",
      "background": "#337ab7"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalUpSaveDevEmbedded
    }
  }, [_vm._v("上書保存")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == false),
      expression: "isAdminSavingApplication == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "-10px"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalSaveDevEmbedded
    }
  }, [_vm._v("下書保存")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideEditMainBtn == false),
      expression: "hideEditMainBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "-10px"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.disableEditMainBtn || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_new == true),
      expression: "is_new == true"
    }]
  }, [_vm._v("「下書保存」ボタンを押したら「ソフトウェア情報」が出ます。")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', [_c('div', {
    style: (_vm.subTableDeviceEmbeddedInformationStyle)
  }, [_c('h3', [_vm._v("ソフトウェア情報")]), _vm._v(" "), (_vm.showAssociatedDevice) ? _c('sub-table-associated_device', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "disable_new_btn": _vm.disableNewToSubTableBtn,
      "disable_edit_btn": _vm.disableEditSubTableBtn,
      "hide_new_btn": _vm.hideNewToSubTableBtn,
      "hide_edit_btn": _vm.hideEditSubTableBtn,
      "disable_all_btn": _vm.disableAllButtons,
      "ref_id": _vm.certificateManagementNumber,
      "fk_id": _vm.certificateSeqId,
      "tag_reload": "reloadSubTableCertificateInformation"
    },
    on: {
      "data-saved": function($event) {
        _vm.subTableSaved()
      }
    }
  }) : _vm._e()], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.is_new == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "-10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.BROWSE) == false
    },
    on: {
      "click": _vm.showHistory
    }
  }, [_vm._v("更新履歴")]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplyConfirmationBtn == false),
      expression: "hideApplyConfirmationBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": function($event) {
        _vm.processApprovalApprove()
      }
    }
  }, [_vm._v("確認")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplyRejectBtn == false),
      expression: "hideApplyRejectBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.processApprovalCancel
    }
  }, [_vm._v("差戻")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplicationBtn == false),
      expression: "hideApplicationBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.disableApplicationBtn || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onConfirmExecuteProcess
    }
  }, [_vm._v("申請")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideCopyMainBtn == false),
      expression: "hideCopyMainBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.cloneRecord
    }
  }, [_vm._v("コピー")])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationUpAddCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationUpAddCheckConfirm
    }
  }), _vm._v(" "), _c('file-modal', {
    attrs: {
      "tag": "showFileModal2"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddcancel"
    },
    on: {
      "done": _vm.processApprovalCancelBack
    }
  }), _vm._v(" "), _c('certificate-information-connection-application-modal', {
    attrs: {
      "tag": "showBulkImportConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationAddCheckConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationAfterSave"
    },
    on: {
      "done": _vm.afterTheNotificationAfterSave
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationAftercancel"
    },
    on: {
      "done": _vm.afterTheNotificationAftercancel
    }
  }), _vm._v(" "), _c('application-confirmation-modal', {
    attrs: {
      "tag": "certificateApplicationConfimationModal"
    }
  }), _vm._v(" "), _c('log-history', {
    attrs: {
      "tag": "showCertificateInformationlogHistoryModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteCertificateInformationDetailModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "font-size": "10px",
      "text-align": "right",
      "color": "red"
    }
  }, [_vm._v("＊入力必須項目")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38f5a77a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0040_certificate_information_detail.vue
// module id = 962
// module chunks = 0